import { useGlobalStore } from "@/frontend/store/GlobalStore";
import { useTreeStore } from "@/frontend/store/TreeStore";
import { I18n } from "@/i18n/I18n";
import { CopyPasteTypes, copyPasteTypes } from "@/types/copyPasteTypes";
import { Dropdown } from "react-bootstrap";
import { ContainerTreeObject } from "@/frontend/types/navigationTypes";

export function CopyItem(props: { instance: CopyPasteTypes, itemId: string, modelLabel?: string }) {
  const { instance, itemId, modelLabel } = props;
  const copyItem = useGlobalStore((state) => state.setCopiedItem);
  const containerLookup = useTreeStore((state) => state.containerLookup);

  const onClickCopy = () => {
    const depth = instance === copyPasteTypes.Section ? maxDepth(containerLookup[itemId]) : 0;
    copyItem({ id: itemId, type: instance, depth });
  };

  return (
    <Dropdown.Item onClick={onClickCopy}>
      {I18n.get('copy', { model: I18n.get(modelLabel || instance) })}
    </Dropdown.Item>
  );
}

const maxDepth = (container: ContainerTreeObject) => {
  const children = container.children.filter((child: ContainerTreeObject) => child.container.isSection());
  let max = 0;
  for (let index = 0; index < children.length; index += 1) {
    const depth = maxDepth(children[index]);
    if (depth > max) {
      max = depth;
    }
    if (max === 2) { return max + 1; }
  }
  return max + 1;
};

